
import { createFileRoute } from '@tanstack/react-router'

import {
  CustomerSignUpPage,
} from '@/features/customersignup/pages/customer-sign-up-page'

export const Route = createFileRoute(
  '/authentication/customer-sign-up/$token',
)({
  component: function CustomerSignUpRoute() {
    const { token } = Route.useParams()

    return <CustomerSignUpPage token={token} />
  },
})
